import { createContext, useContext } from "react";
import { type Key, type Locale, translate, translateError } from "./index";

export const LocaleContext = createContext<Locale>("en");

/** Picks the language for this device (decision 133); a no-op outside the app. */
export const LocaleChoiceContext = createContext<(locale: Locale) => void>(() => undefined);

/** `t` for the current locale; every visible string goes through it (gate 15). */
export function useT() {
  const locale = useContext(LocaleContext);
  return {
    locale,
    t: (key: Key, params?: Record<string, string | number>) => translate(locale, key, params),
    err: (code: string) => translateError(locale, code),
  };
}
